<template>
	<div
		v-if="!bookings || bookings.length === 0"
		class="row"
		style="padding: 30px"
	>
		<div class="col-12 center">
			<h5 class="red-text">No bookings data available</h5>
			<button @click="closeModal" class="waves-effect waves-light btn">
				Close
			</button>
		</div>
	</div>

	<div v-else class="row" style="padding: 30px">
		<div class="row">
			<div class="col-12">
				<h4 class="teal-text">
					<span>{{
						bookings && bookings.length > 0
							? bookings[0].location
							: "No Location"
					}}</span>
				</h4>
				{{ day }} | {{ time }}
			</div>
		</div>
		<div
			class="row"
			style="height: 420px; border: 1px solid grey; overflow-y: scroll"
		>
			<div class="col m6">
				<table class="table striped">
					<thead>
						<th>Morning Shift</th>
					</thead>
					<tbody>
						<tr
							v-for="booking in sortedMorningBookings"
							:key="booking._id"
						>
							<td>
								<div class="row" style="margin-bottom: 0">
									<div
										class="col-12"
										style="padding-left: 15px; padding-right: 0"
									>
										{{ booking.employee }}
									</div>
								</div>
								<div class="row" style="margin-bottom: 0">
									<div
										class="col-12 grey-text text-darken-1"
										style="
											font-size: 0.65em;
											padding-left: 15px;
											padding-right: 0;
										"
									>
										booked: {{ booking.created }}
									</div>
								</div>
							</td>
							<td>
								<!-- <span v-if="booking.approved == true || booking.approved == null" class="new badge teal" data-badge-caption=" ">Approved</span>
                  <span v-if="booking.approved == false" class="new badge red" data-badge-caption=" ">Not Approved</span> -->
								<span
									v-if="
										booking.license_plate && user.permission != 100
									"
									class="new badge orange"
									data-badge-caption=""
									style="color: black"
									><strong>{{ booking.license_plate }}</strong></span
								>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="col m6">
				<table class="table striped">
					<thead>
						<th>Afternoon Shift</th>
					</thead>
					<tbody>
						<!-- order by createdDate -->
						<tr
							v-for="booking in sortedAfternoonBookings"
							:key="booking._id"
						>
							<td>
								<div class="row" style="margin-bottom: 0">
									<div
										class="col-12"
										style="padding-left: 15px; padding-right: 0"
									>
										{{ booking.employee }}
									</div>
								</div>
								<div class="row" style="margin-bottom: 0">
									<div
										class="col-12 grey-text text-darken-1"
										style="
											font-size: 0.65em;
											padding-left: 15px;
											padding-right: 0;
										"
									>
										booked: {{ booking.created }}
									</div>
								</div>
							</td>
							<td>
								<!-- <span v-if="booking.approved == true || booking.approved == null" class="new badge teal" data-badge-caption=" ">Approved</span> -->
								<!-- <span v-if="booking.approved == false" class="new badge red" data-badge-caption=" ">Not Approved</span> -->
								<span
									v-if="
										booking.license_plate && user.permission != 100
									"
									class="new badge orange"
									data-badge-caption=" "
									style="color: black"
									><strong>{{ booking.license_plate }}</strong></span
								>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script> 
import addBooking from "@/components/modals/addBooking";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import firebase from "firebase";
export default {
	name: "viewDayBookings",
	data() {
		return {
			morningBookings: [],
			afternoonBookings: [],
			name_employee: null,
			time: null,
			day: null,
			feedback: null,
			success: false,
			user: null,
		};
	},
	props: {
		bookings: {
			type: Array,
			required: true,
			default: () => [],
		},
	},
	computed: {
		...mapGetters(["selectedOffice"]),
		sortedMorningBookings() {
			return [...this.morningBookings].sort(
				(a, b) => a.createdDate - b.createdDate
			);
		},
		sortedAfternoonBookings() {
			return [...this.afternoonBookings].sort(
				(a, b) => a.createdDate - b.createdDate
			);
		},
	},
	methods: {
		...mapActions(["createBooking"]),
		closeModal() {
			this.$emit("close");
		},
		sortBookings(bookings) {
			// Reset arrays before sorting
			this.morningBookings = [];
			this.afternoonBookings = [];

			for (var i = 0; i < bookings.length; i++) {
				if (bookings[i].shift == 1) {
					// Shift 1: Full day (both morning and afternoon)
					this.morningBookings.push(bookings[i]);
					this.afternoonBookings.push(bookings[i]);
				} else if (bookings[i].shift == 2) {
					// Shift 2: Morning only
					this.morningBookings.push(bookings[i]);
				} else if (bookings[i].shift == 3) {
					// Shift 3: Afternoon only
					this.afternoonBookings.push(bookings[i]);
				}
			}
			this.morningBookings.sort((a, b) =>
				a.employee > b.employee ? 1 : b.employee > a.employee ? -1 : 0
			);
			this.afternoonBookings.sort((a, b) =>
				a.employee > b.employee ? 1 : b.employee > a.employee ? -1 : 0
			);

		},
	},
	mounted() {
		console.log("viewDayBookings mounted with bookings:", this.bookings);
		if (this.bookings) {
			console.log("Bookings length:", this.bookings.length);
			console.log("First booking:", this.bookings[0]);
		}
	},
	created() {
		// Add safety checks for bookings
		if (!this.bookings || this.bookings.length === 0) {
			console.error("No bookings provided to viewDayBookings modal");
			this.time = "No Date";
			this.day = "No Day";
			return;
		}

		//WINTER TIME
		this.time = moment(this.bookings[0].timestamp + 3600000).format("Do MMM");
		this.day = moment(this.bookings[0].timestamp + 3600000).format("dddd");
		//WINTER TIME
		this.user = firebase.auth().currentUser;
		this.name_employee = this.user ? this.user.displayName : "Unknown User";
		this.sortBookings(this.bookings);
	},
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/modals/viewDayBookings.vue